export default __webpack_public_path__ + "static/media/lets-play.101fdfa0.gif";